import { render } from "./Generations.vue?vue&type=template&id=a37b1044"
import script from "./Generations.vue?vue&type=script&lang=js"
export * from "./Generations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__